<input
  #phoneInput
  class="form-control"
  [ngClass]="ngClassesList"
  type="tel"
  [disabled]="isDisabled"
  (keyup)="handleKeyUp()"
/>
